import Vue from 'vue';
import Router from 'vue-router';
import CompositionSearch from '@/components/CompositionSearch.vue';
import CompositionUpload from '@/components/CompositionUpload.vue';
import Home from '@/views/Home.vue';
import Phases from '@/views/Phases.vue';
import Samples from '@/views/Samples.vue';
import Compositions from '@/views/Compositions.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/samplesScreen',
            name: 'samplesScreen',
            component: Samples,
        },
        {
            path: '/phasesScreen',
            name: 'phasesScreen',
            component: Phases,
        },
        {
            path: '/searchScreen',
            name: 'searchScreen',
            component: CompositionSearch,
        },
        {
            path: '/uploadScreen',
            name: 'uploadScreen',
            component: CompositionUpload,
        },
    ],
});
